import React, { ComponentType } from 'react'
import classNames from 'classnames'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult, StructuredSummaryResultType } from '../../../../../../../models/AiResult'
import { StructuredSummaryMeetingResultView } from './StructuredSummaryMeetingResultView'
import { TextMeetingResultProps } from './TextMeetingResult'
import './MapMeetingResults.scss'
import { getSafeValueOnPath } from '../../../utils'

interface MapMeetingResultProps {
  aiFeature: AiFeature
  aiResult: AiResult
  basePath: string
  path: string
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
  parentHasMapValue?: boolean
  CustomTextMeetingResult?: ComponentType<TextMeetingResultProps>
}

export const MapMeetingResult: React.FC<MapMeetingResultProps> = ({
  aiFeature,
  aiResult,
  basePath,
  path,
  onFormattedResultChange,
  parentHasMapValue = false,
  CustomTextMeetingResult,
}) => {
  const result: { [key: string]: StructuredSummaryResultType | StructuredSummaryResultType[] } =
    getSafeValueOnPath(getSafeValueOnPath(aiResult.result, basePath), path, {}) ?? {}

  const hasMapValue = Object.values(result).some((resultValue: StructuredSummaryResultType) =>
    Array.isArray(resultValue) ? resultValue.some((arrayValue) => typeof arrayValue === 'object') : typeof resultValue === 'object',
  )

  return (
    <>
      {Object.keys(result).map((key, idx) => {
        return (
          <div
            className={classNames('d-flex flex-column gap-1 py-1', {
              'px-2': !parentHasMapValue,
              'map-result-divider': hasMapValue,
            })}
            key={`map_${idx}`}
          >
            <div
              className={classNames({
                'lead-small': !hasMapValue,
                'paragraph-large bold mb-3': hasMapValue,
              })}
            >
              {key}
            </div>
            <StructuredSummaryMeetingResultView
              aiResult={aiResult}
              aiFeature={aiFeature}
              basePath={basePath}
              path={`${path}["${key}"]`}
              className='ps-0'
              onFormattedResultChange={onFormattedResultChange}
              displayAsList
              parentHasMapValue={hasMapValue}
              CustomTextMeetingResult={CustomTextMeetingResult}
            />
          </div>
        )
      })}
    </>
  )
}
